import { render, staticRenderFns } from "./AIPanel.vue?vue&type=template&id=65dc72df&"
import script from "./AIPanel.vue?vue&type=script&lang=ts&"
export * from "./AIPanel.vue?vue&type=script&lang=ts&"
import style0 from "./AIPanel.vue?vue&type=style&index=0&id=65dc72df&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports